import React from "react";
import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  DRAFT: "bg-slate-500/10 text-slate-400 border-slate-500/30",
  SUBMITTED: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  "UNDER REVIEW": "bg-purple-500/10 text-purple-400 border-purple-500/30",
  "CORRECTION REQUIRED": "bg-amber-500/10 text-amber-400 border-amber-500/30",
  APPROVED: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30",
  REJECTED: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  LIVE: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  OPEN: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  "IN PROGRESS": "bg-purple-500/10 text-purple-400 border-purple-500/30",
  "WAITING FOR USER": "bg-amber-500/10 text-amber-400 border-amber-500/30",
  RESOLVED: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  CLOSED: "bg-slate-500/10 text-slate-400 border-slate-500/30",
};

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-muted text-muted-foreground border-border";
  return (
    <Badge variant="outline" className={`font-medium ${cls}`} data-testid={`status-badge-${status}`}>
      {status}
    </Badge>
  );
}
